import config from 'config'
import selector, {identitySelector} from 'utils/selector'
import ChromeExtensionService from './ChromeExtensionService'

/**
 * In this context, we are in the popup chrome extension application
 */

export default class ChromePopupService extends ChromeExtensionService {
  public get serviceName() {
    return 'popupApp'
  }

  public close = () => {
    if (config.shouldTestChromeApp) {
      const node = document.getElementById('__itx-popup-app-stub')
      if (node) {
        node.parentElement?.removeChild(node)
      }
      return
    }
    window.close()
  }
}

export const chromePopupServiceSelector = selector(identitySelector<string>(), () => new ChromePopupService())
